import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import { DocumentosReporte, EncApi, LasMonedas, TiposExportacion } from '../Comunes/Listas';
import { useAuth } from '../contextos/AuthProvider'
import { useNavigate } from 'react-router-dom';
import { Chart } from 'react-google-charts';

const Reportes = () => {
    const [chartData, setChartData] = React.useState([]);
    const { PerfilUsuario, Token } = useAuth();
    const [Gestor, setGestor] = React.useState(null);

    const Meses = [
        { value: 1, span: 'Enero' },
        { value: 2, span: 'Febrero' },
        { value: 3, span: 'Marzo' },
        { value: 4, span: 'Abril' },
        { value: 5, span: 'Mayo' },
        { value: 6, span: 'Junio' },
        { value: 7, span: 'Julio' },
        { value: 8, span: 'Agosto' },
        { value: 9, span: 'Septiembre' },
        { value: 10, span: 'Octubre' },
        { value: 11, span: 'Noviembre' },
        { value: 12, span: 'Diciembre' }
    ];

    const Modificar = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'Moneda':
                RefrescaTabla(value);
                break;

            case 'Doc':
                setGestor((prevState) => ({
                    ...prevState,
                    Doc: value,
                    MesD151: value === 'D151'
                        ? (prevState.MesD151 || new Date().getMonth() + 1)
                        : prevState.MesD151,
                    AnnioD151: value === 'D151'
                        ? (prevState.AnnioD151 || new Date().getFullYear())
                        : prevState.AnnioD151
                }));
                break;

            default:
                setGestor((prevState) => ({
                    ...prevState,
                    [name]: value
                }));
        }
    }

    const navigate = useNavigate();

    const PeriodoMesAnterior = () => {
        const fecha = new Date();

        fecha.setMonth(fecha.getMonth() - 1);

        return {
            mes: fecha.getMonth() + 1,
            annio: fecha.getFullYear()
        };
    }

    const DatosIniciales = async () => {
        const URL = 'https://SmartFeCr.com:2020/SmartContrackBack/api/SmartFeCr/IniciandoReportes?bdCia=' + PerfilUsuario.BD + '&moneda=CRC';
        console.log(URL);

        const response = await fetch(URL, EncApi(Token));
        const data = await response.json();

        const periodoAnterior = PeriodoMesAnterior();

        setGestor({
            ...data,
            MesD151: periodoAnterior.mes,
            AnnioD151: periodoAnterior.annio
        });

        ConstruirTabla(data.DashBore);
    }

    const RefrescaTabla = async (Moneda) => {
        const URL = 'https://SmartFeCr.com:2020/SmartContrackBack/api/SmartFeCr/SoloDashBore?bdCia=' + PerfilUsuario.BD + '&moneda=' + Moneda;

        const response = await fetch(URL, EncApi(Token));
        const data = await response.json();

        setGestor((prevState) => ({
            ...prevState,
            DashBore: data,
            Moneda: Moneda
        }));

        ConstruirTabla(data);
    }

    const ConstruirTabla = (data) => {
        const agrupados = data.reduce((acc, item) => {
            if (!acc[item.Periodo]) {
                acc[item.Periodo] = {};
            }
            if (!acc[item.Periodo][item.Tipo]) {
                acc[item.Periodo][item.Tipo] = 0;
            }
            acc[item.Periodo][item.Tipo] += item.Monto;
            return acc;
        }, {});

        const encabezados = ['Período', ...new Set(data.map(item => item.Tipo))];

        const filas = Object.entries(agrupados).map(([periodo, tipos]) => {
            const valores = encabezados.slice(1).map(tipo => tipos[tipo] || 0);
            return [periodo, ...valores];
        });

        setChartData([encabezados, ...filas]);
    }

    const handleOnSubmit = (e) => {
        e.preventDefault();
    }

    const Salir = () => {
        navigate("/");
    }

    const DescargarArchivoBase64 = (base64, nombreArchivo, mimeType) => {
        const tempLink = document.createElement('a');
        tempLink.href = `data:${mimeType};base64,${base64}`;
        tempLink.setAttribute('download', nombreArchivo);
        tempLink.click();
    }

    const GenerarReporteD151 = async () => {
        const URL = 'https://smartfecr.com:2017/api/Reportes/ReporteD151?IdCia='
            + PerfilUsuario.IdCia
            + '&Mes=' + Gestor.MesD151
            + '&Annio=' + Gestor.AnnioD151;

        console.log(URL);

        Swal.fire({
            title: 'Generando reporte D151...',
            text: 'Por favor, espere mientras se genera el documento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await fetch(URL, { method: 'GET' });

            if (!response.ok) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo generar el reporte D151.',
                    confirmButtonText: 'Aceptar'
                });
                return;
            }

            const data = await response.json();

            DescargarArchivoBase64(
                data.Result,
                'Reporte_D151.pdf',
                'application/pdf'
            );

            Swal.close();

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo generar el reporte D151.',
                confirmButtonText: 'Aceptar'
            });
        }
    }

    const GenerarReporte = async () => {
        if (Gestor.Doc === 'D151') {
            await GenerarReporteD151();
            return;
        }

        const URL = Gestor.Formatos !== 'XLS' ? 'https://smartfecr.com:2017/api/Reportes/ReportesGenerales?BDCompania='
            + PerfilUsuario.BD
            + '&IdCia=' + PerfilUsuario.IdCia
            + '&Doc=' + Gestor.Doc
            + '&Formato=' + Gestor.Formatos
            + '&Desde=' + Gestor.txtDel
            + '&Hasta=' + Gestor.txtAl : 'https://SmartFeCr.com:2020/SmartContrackBack/api/DocumentosElectronicos/ExcelReportes?IdCia=' + PerfilUsuario.IdCia + '&BdCia='
            + PerfilUsuario.BD
            + '&CboTipDoc=' + Gestor.Doc
            + '&FecDesde=' + Gestor.txtDel
            + '&FecHasta=' + Gestor.txtAl;

        console.log(URL);

        Swal.fire({
            title: 'Generando reporte...',
            text: 'Por favor, espere mientras se genera el documento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await fetch(URL, Gestor.Formatos === 'XLS' ? EncApi(Token) : { method: 'GET' });
            const data = await response.json();

            console.log(data);

            let ElArchivo = '';

            if (Gestor.Formatos === 'XLS') {
                if (data.Codigo === 0) {
                    ElArchivo = data.Mensaje;
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: data.Mensaje,
                    });
                    return;
                }
            } else {
                ElArchivo = data.Result;
            }

            let mimeType = '';
            let fileExtension = '';

            switch (Gestor.Formatos) {
                case 'PDF':
                    mimeType = 'application/pdf';
                    fileExtension = '.pdf';
                    break;
                case 'XLS':
                    mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    fileExtension = '.xlsx';
                    break;
                case 'XLSS':
                    mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    fileExtension = '.xls';
                    break;
                case 'DOC':
                    mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                    fileExtension = '.doc';
                    break;
                default:
                    console.error('Formato no soportado:', Gestor.Formatos);
                    return;
            }

            DescargarArchivoBase64(
                ElArchivo,
                'Reporte_' + Gestor.Doc + fileExtension,
                mimeType
            );

            Swal.close();

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo generar el reporte.',
                confirmButtonText: 'Aceptar'
            });
        }
    }

    useEffect(() => {
        DatosIniciales();
        // eslint-disable-next-line
    }, []);

    if (PerfilUsuario && Gestor) {
        return (
            <div className='main-block'>
                <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                    <div className='formadoShadow'>

                        <div className='tituloPantalla'>
                            <p style={{ display: 'inline-block' }}> Reportes SmartFE</p>
                            <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome">
                                <i className="fa fa-times"></i>
                            </button>
                        </div>

                        <div className='row'>
                            <div className="col-25">
                                <span className="col-form-span">Nombre Reporte </span>
                                <select id="Doc" name="Doc" className="form-group"
                                    onChange={Modificar} value={Gestor.Doc}>
                                    {DocumentosReporte.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}
                                </select>
                            </div>

                            {Gestor.Doc !== 'D151' && (
                                <>
                                    <div className="col-25">
                                        <span className="col-form-span">Del día </span>
                                        <input type="date" id="txtDel" onChange={Modificar} name="txtDel"
                                            value={Gestor.txtDel}></input>
                                    </div>

                                    <div className="col-25">
                                        <span className="col-form-span">Al día </span>
                                        <input type="date" id="txtAl" onChange={Modificar} name="txtAl"
                                            value={Gestor.txtAl}></input>
                                    </div>

                                    <div className='col-25'>
                                        <span className="col-form-span">Formato </span>
                                        <select id="Formatos" name="Formatos" className="form-group"
                                            onChange={Modificar} value={Gestor.Formatos}>
                                            {TiposExportacion.map((option, i) => (
                                                <option key={i} value={option.value}>{option.span}</option>
                                            ))}
                                        </select>
                                    </div>
                                </>
                            )}

                            {Gestor.Doc === 'D151' && (
                                <>
                                    <div className="col-25">
                                        <span className="col-form-span">Mes </span>
                                        <select id="MesD151" name="MesD151" className="form-group"
                                            onChange={Modificar} value={Gestor.MesD151}>
                                            {Meses.map((option, i) => (
                                                <option key={i} value={option.value}>{option.span}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-25">
                                        <span className="col-form-span">Año </span>
                                        <input type="text" id="AnnioD151" name="AnnioD151"
                                            onChange={Modificar}
                                            value={Gestor.AnnioD151}
                                            maxLength="4"></input>
                                    </div>

                                    <div className='col-25'></div>
                                </>
                            )}
                        </div>

                        <div className='row'>
                            <div className='col-25'>
                                <button className="boton" id="btnGenerar" onClick={() => GenerarReporte()} name="btnGenerar">
                                    Generar
                                </button>
                            </div>
                            <div className='col-75'></div>
                        </div>

                        <div name="grafico" style={{ marginTop: '20px' }}>
                            {chartData.length > 0 && (
                                <Chart
                                    chartType="ColumnChart"
                                    width="100%"
                                    height="500px"
                                    data={chartData}
                                    options={{
                                        title: 'Documentos por Período',
                                        hAxis: { title: 'Período', titleTextStyle: { color: '#333' } },
                                        vAxis: { minValue: 0 },
                                        isStacked: true,
                                    }}
                                />
                            )}
                        </div>

                        <div className='row'>
                            <div className='col-25'>
                                <select id="Moneda" name="Moneda" className="form-group"
                                    onChange={Modificar} value={Gestor.Moneda}>
                                    {LasMonedas.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-75'></div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f9f9f9',
                fontFamily: 'Arial, sans-serif',
                color: '#555',
                textAlign: 'center'
            }}>
                <div>
                    <p style={{
                        fontSize: '18px',
                        marginBottom: '10px'
                    }}>Cargando Información...</p>
                    <p style={{
                        fontSize: '14px',
                        color: '#888'
                    }}>Por favor, espere mientras se cargan los datos necesarios.</p>
                </div>
            </div>
        );
    }
};

export default Reportes;